/*
see dealer.site.cta.js
// available on instances:
enterZip() or beginSearch(zip)

 // Also available on instances:
 setMode('identity') (non-pma)
 setMode('pma') default
 setMode('mirai') mirai dealers only. Also modifies query. Go figure
*/

import $ from 'jquery';
import Handlebars from 'handlebars';
import zip from 'lib/util/zip';
import batws from 'lib/services/batws';
import Paginator from 'lib/paginator';
import xformDealersCommon from 'lib/transforms/dealer.tmpl.common';
import txtDealerSearchModalZip from 'tmpl/dealer.search.modal.zip.hbs';
import txtDealerSearchModal from 'tmpl/dealer.search.modal.hbs';
import txtDealerSearchResults from 'tmpl/dealer.search.modal.results.hbs';
import txtDealerSearchFooter from 'tmpl/dealer.search.modal.footer.hbs';
import langFromUrl from 'lib/util/langFromUrl';
import zipTools from 'components/zip-tools';
import tdaConfig from 'lib/util/tda.config';
import anClicks from 'lib/analytics/click';
import anClickManual from 'lib/analytics/click.manual';
import anPageLoadOverall from 'lib/analytics/pageloadOverall';
import anAddContext from 'lib/analytics/context.add';
import blocks from 'lib/analytics/blocks/index';
import 'lib/helpers/toJSON';
import 'lib/helpers/ifCond';
import 'bootstrapModal';
import 'lib/validator';

var __lang = langFromUrl();
var __tmplDealerSearchModalZip = Handlebars.compile(txtDealerSearchModalZip);
var __tmplDealerSearchModal = Handlebars.compile(txtDealerSearchModal);
var __tmplDealerResults = Handlebars.compile(txtDealerSearchResults);
var __tmplDealerFooter = Handlebars.compile(txtDealerSearchFooter);
var __initialized = false;
var __currZip = zip.getCookiedDefaultFallback();

function __dealerQuery(opts) {
  var paginatorOpts = {
    query: {},
    dataField: 'dealerLocator',
    countField: 'dealerCount',
    xform: xformDealersCommon,
    pageSize: 5
  };
  return $.extend(paginatorOpts, opts);
}

function __sameTda(res) {
  if (res.records[0].tdaCode === tdaConfig.tda.code) {
    return true;
  }
  return false;
}

var __identityFilter = function () {
  return true;
};

var __pmaFilter = function (dealer) {
  return dealer.isPma;
};

var __miraiOnly = function (dealer) {
  return dealer.isMirai;
};

var dealerSearchModal = {
  setMode: function (mode) {
    this.mode = mode;
    if (mode === 'pma') {
      this.filter = __pmaFilter;
    } else if (mode === 'mirai') {
      // not just filter here, also need to modify the query. God damn it
      this.filter = __miraiOnly;
    } else if (mode === 'autoSelectSinglePMA') {
      // returns PMA dealers, but with special results
      this.filter = __pmaFilter;
    } else {
      this.filter = __identityFilter;
    }
    // save the default mode, as we need to change it back on zip code change
    if (!this.startMode) {
      this.startMode = this.mode;
    }
  },

  resetMode: function () {
    this.setMode(this.startMode); // reset our mode to its OG mode when user begins edit zip
  },

  showLoader: function () {
    $('#dealer-search-modal .loader').show();
  },

  hideLoader: function () {
    $('#dealer-search-modal .loader').hide();
  },

  enterZip: function (keyMetrics) {
    var self = this;
    var $modalOutputNode = $('#modal-output-node');
    var $modalZipEnter;
    var $modalZipEnterForm;
    var copy = self.getCopyForModal(keyMetrics);

    $modalOutputNode.html(__tmplDealerSearchModalZip(copy[__lang]));
    $modalZipEnter = $('#dealer-search-modal-zip');
    $modalZipEnter.modal('show');
    $modalZipEnterForm = $('form.js-dealer-search-modal-zip', $modalZipEnter);
    setTimeout(function () {
      anPageLoadOverall($modalZipEnter, blocks.sectionBlock('locate dealer zip modal'));
    }, 5);

    var closeBtn = $('#dealer-search-modal-zip .close-ground');
    var findBtn = $('.js-dealers-zip');
    closeBtn.attr('data-linktext', 'close');
    findBtn.attr('data-linkmodule', 'user_zip');
    anAddContext(closeBtn, blocks.listItemBlock(0), blocks.sectionBlock('locate dealer zip modal'));
    anAddContext(findBtn, blocks.listItemBlock(2), blocks.sectionBlock('locate dealer zip modal'));


    // enter zip modal listeners
    $modalZipEnterForm.validate({
      rules: {
        userZip: { zipcodeUS: true }
      },
      submitHandler: function (form) {
        self.checkZip(keyMetrics);
      },
      invalidHandler: function () {
        // eslint-disable-next-line no-restricted-globals
        if (event && event.type === 'submit') {
          anAddContext(findBtn, blocks.dealerSearchBlock('', 'zip'));
          anClickManual($modalZipEnter, findBtn);
        }
      }
    });
    $modalZipEnter.find('.close-ground').on('click', function () {
      anClickManual($modalZipEnter, closeBtn);
    });

    $modalZipEnterForm.on('submit', function (e) {
      e.preventDefault();
    });

    /*
      At times, we need to see if this modal was dismissed 'manually' aka, not dismissed by zip form submission (see dealer GXP CTA)
      We don't have much to go on to determine that, except if the form was invalid (which isn't TOTALLY accurate)
      so if this modal is 'dismissed', and the form within it was invalid, then we invoke our modalDismiss func, provided by the instance
    */
    $modalZipEnter.on('hide.bs.modal', function (e) {
      var userDismissed = !$modalZipEnterForm.valid();
      if (userDismissed && self.modalDismiss && typeof self.modalDismiss === 'function') {
        self.modalDismiss();
      }
    });
  },

  checkZip: function (keyMetrics) {
    var self = this;
    var enteredZip = $('#find-a-dealer-search-value', '#dealer-search-modal-zip').val();

    if (zip.isZipFormatValid(enteredZip)) {
      $('#dealer-search-modal-zip').on('hidden.bs.modal', function () {
        self.beginSearch(enteredZip, keyMetrics);
      });
      $('#dealer-search-modal-zip').modal('hide');
    } else {
      self.invalidZip($('#dealer-search-modal-zip'));
    }
  },

  invalidZip: function ($currentModal) {
    var self = this;
    $currentModal.on('hidden.bs.modal', function () {
      function finalCallback(resZip, tdaChanged) {
        if (tdaChanged) return;
        self.beginSearch(resZip);
      }
      zipTools.showInvalidZipModal(__currZip, __currZip, null, finalCallback, false, false, false);
    });
    $currentModal.modal('hide');
  },

  beginSearch: function (calcZip, keyMetrics) {
    var self = this;
    self.searchedZip = calcZip;
    var findBtn = $('.js-dealers-zip');
    var $modalZipEnter = $('#dealer-search-modal-zip');
    if (!self.mode) {
      self.setMode('pma');
    }
    var query = __dealerQuery({
      query: {
        zipcode: calcZip,
        mirai: self.mode === 'mirai'
      }
    });
    // ensures we are showing at least a loading modal
    self.buildResultsModal(calcZip, keyMetrics);
    self.paginator = new Paginator(batws.geo().search, query);
    self.paginator.next()
      .then(function (res) {
        // no records, consider it an invalide zip
        if (!res.records.length) {
          self.invalidZip($('#dealer-search-modal'));
          return;
        }
        if (__sameTda(res)) {
          self.showResults(res, keyMetrics);
        } else {
          $('#dealer-search-modal').on('hidden.bs.modal', function () {
            var changeToZip = res.records[0].zipCode;
            zipTools.changeZip(__currZip, changeToZip, window.location.pathname, null, false, false, false, false);
          });
          $('#dealer-search-modal').modal('hide');
        }
        anAddContext(findBtn, blocks.dealerSearchBlock(self.searchedZip, 'zip', res.count, 'Toyota'));
        anClickManual($modalZipEnter, findBtn);
      })
      .catch(function (err) { console.error('Visit Dealer CTA paginator error: ', err); }); // eslint-disable-line no-console
  },

  buildResultsModal: function (calcZip, keyMetrics) {
    var self = this;
    var headerTxt = self.getHeaderTextForResultsModal(keyMetrics);
    var $resultModal = $('#dealer-search-modal');
    $('#modal-output-node').html(__tmplDealerSearchModal({
      userZip: calcZip,
      headerTxt: headerTxt[__lang].title,
      subheaderTxt: headerTxt[__lang].subheading
    }));
    // IF TDA of first dealer is no good, do something else here.
    $('#dealer-search-modal').modal('show');
    setTimeout(function () {
      anPageLoadOverall($resultModal, blocks.sectionBlock('locate dealer zip results modal'));
    }, 1500);
    anClicks('#dealer-search-modal');
    this.showLoader();
  },

  viewAll: function (e, keyMetrics) {
    e.preventDefault();
    this.setMode('all');
    this.showResults(this.paginator.pageData, keyMetrics);
  },

  showResults: function (res, keyMetrics) {
    var self = this;
    var dealerData = $.extend({}, res, {
      records: res.records.filter(self.filter)
    });
    // Better spot for copy
    var actionsFooter = {
      en: {
        title: 'View More Dealers',
        url: '#'
      },
      es: {
        title: 'Ver más concesionarios',
        url: '#'
      }
    };
    var dataCopy = {
      en: {
        miles: 'miles',
        next: 'Next',
        prev: 'Previous',
        of: 'of',
        noDealersTitle: 'No Dealers Found',
        noDealersCopy: 'Please <a href="#" class="js-search-restart">search again</a> using a different location.',
        btnText: 'Select'
      },
      es: {
        miles: 'millas',
        next: 'Siguiente',
        prev: 'Anterior',
        of: 'de',
        noDealersTitle: 'No encontramos concesionarios',
        noDealersCopy: 'Por favor <a href="#" class="js-search-restart">busca nuevamente</a> con otra dirección.',
        btnText: 'Elegir'
      }
    };

    if (self.mode === 'autoSelectSinglePMA' && dealerData.hasNext === false && dealerData.hasPrev === false) {
      self.chooseDealer(null, dealerData.records[0].dealerCode); // provide the zip code that user searched on
    } else {
      self.hideLoader();
      anAddContext(
        $('#dealer-search-modal .search-modal-results'),
        blocks.sectionBlock('locate dealer zip results modal'),
        blocks.listItemBlock(2)
      );
      // update results area
      if (window.location.href.endsWith('/inventory/')) {
        $('#dealer-search-modal .search-modal-results')
          .html(__tmplDealerResults({
            dealerResults: dealerData,
            resultCopy: dataCopy[__lang]
          }));
      } else {
        $('#dealer-search-modal .search-modal-results')
          .html(__tmplDealerResults({
            dealerResults: dealerData,
            resultCopy: dataCopy[__lang]
          }));
      }

      $('#dealer-search-modal .body-footer')
        .html(__tmplDealerFooter({
          page: dealerData,
          action: actionsFooter[__lang],
          pma: self.filter === __pmaFilter,
          resultCopy: dataCopy[__lang]
        }));

      self.dealerEvents(keyMetrics);
      // Only attach modalEvents if we haven't done so already
      if (!__initialized) {
        self.modalEvents(keyMetrics);
      }
    }
  },

  modalEvents: function (keyMetrics) {
    var self = this;
    var $dealerSearchModal = $('#dealer-search-modal');
    var viewAllDealersBtn = $('.js-dealers-all');

    anAddContext(
      viewAllDealersBtn,
      blocks.listItemBlock(3),
      blocks.sectionBlock('locate dealer zip results modal'),
      blocks.keyMetrics('km-dealer-search'),
      blocks.dealerSearchBlock(this.searchedZip, 'zip', this.paginator.count, 'Toyota')
    );
    $('.js-dealers-all', '#dealer-search-modal').on('click', function (e) {
      anClickManual($dealerSearchModal, e.target);
      self.viewAll(e, keyMetrics);
    });

    anAddContext(
      $('.js-edit-zip'),
      blocks.dealerBlock(this.paginator.pageData.records[0]),
      blocks.sectionBlock('locate dealer zip results modal'),
      blocks.listItemBlock(1)
    );
    $('.js-edit-zip', '#dealer-search-modal').on('click', function (e) {
      e.preventDefault();
      self.editZip(keyMetrics);
    });

    var closeResultBtn = $('.close-ground');
    closeResultBtn.attr('data-linktext', 'close');
    anAddContext(
      closeResultBtn,
      blocks.listItemBlock(0),
      blocks.sectionBlock('locate dealer zip results modal'),
      blocks.dealerBlock(this.paginator.pageData.records[0])
    );
    closeResultBtn.click(function () {
      anClickManual($dealerSearchModal, closeResultBtn);
    });

    // todo: account for modal dismissal from here too
    $('#dealer-search-modal').on('hidden.bs.modal', function () {
      __initialized = false;
    });

    __initialized = true;
  },

  dealerEvents: function (keyMetrics) {
    var self = this;
    // reuse the dealer action for the Chat CTA, but besides selecting the
    // dealer and open in a new window, need to initialize the chat
    if (keyMetrics && keyMetrics === 'live-chat-liveperson') {
      $('.dealer-action a', '#dealer-search-modal').on('click', function (e) {
        $('#dealer-search-modal').modal('hide');
        self.initLivePersonChat(e, $(this).data('dealercode'));
      });
    } else {
      // Click event on actual Dealer Selection. Needs to be provided
      // via dealerSelect func on instance
      $('.dealer-action a', '#dealer-search-modal').on('click', function (e) {
        $('#dealer-search-modal').modal('hide');
        self.chooseDealer(e, $(this).data('dealercode'));
      });
    }
    anAddContext($('.js-page-prev'), blocks.sectionBlock('locate dealer zip modal'));
    $('.js-page-prev', '#dealer-search-modal').on('click', function (e) {
      e.preventDefault();
      self.prevPage(keyMetrics);
    });

    anAddContext($('.js-page-next'), blocks.sectionBlock('locate dealer zip modal'));
    $('.js-page-next', '#dealer-search-modal').on('click', function (e) {
      e.preventDefault();
      self.nextPage(keyMetrics);
    });
  },

  // always provide the selected dealer back
  // provide the originally searched for zip, back to func
  chooseDealer: function (e, dealerCode) {
    var selectedDealer;
    if (this.dealerSelect && typeof this.dealerSelect === 'function') {
      selectedDealer = this.paginator.pageData.records.find(dealer => dealer.dealerCode == dealerCode); // eslint-disable-line eqeqeq
      this.dealerSelect(e, selectedDealer, this.searchedZip);
    }
  },

  initLivePersonChat: function (e, dealerCode) {
    if (this.initChat && typeof this.initChat === 'function') {
      this.initChat(e, dealerCode);
    }
  },

  nextPage: function (keyMetrics) {
    var self = this;
    if (self.paginator.hasNext()) {
      self.showLoader();
      self.paginator.next()
        .then(function (res) {
          self.showResults(res, keyMetrics);
        })
        .catch(function (err) { console.error('Paginator next error: ', err); }); // eslint-disable-line no-console
    }
  },

  prevPage: function (keyMetrics) {
    if (this.paginator.hasPrev()) {
      this.showResults(this.paginator.prev(), keyMetrics);
    }
  },

  editZip: function (keyMetrics) {
    var self = this;
    self.resetMode();
    $('#dealer-search-modal').on('hidden.bs.modal', function () {
      self.enterZip(keyMetrics);
    });
    $('#dealer-search-modal').modal('hide');
  },

  // The dealer search modal has different copy when initiated from the
  // Chat with Dealer CTA
  getCopyForModal: function (keyMetrics) {
    var copy = {};
    if (keyMetrics && keyMetrics === 'live-chat-liveperson') {
      copy = {
        en: {
          title: 'Chat With A Local Dealer',
          body: 'Set your zip code and select a local dealer to start chatting.',
          placeholder: 'Enter ZIP code',
          cta: 'Find'
        },
        es: {
          title: 'Hablar con un dealer local',
          body: 'Pon tu código postal para hablar con un dealer local.',
          placeholder: 'C&#x00F3;digo postal',
          cta: 'Buscar'
        },
      };
    } else {
      copy = {
        en: {
          title: 'Looking for a dealership?',
          body: 'To select a dealer in your area, please enter your ZIP code.',
          placeholder: 'Enter ZIP code',
          cta: 'Find'
        },
        es: {
          title: 'Buscando un concesionario?',
          body: 'Para seleccionar un distribuidor en su &#x00E1;rea, por favor, introduzca su c&#x00F3;digo postal.',
          placeholder: 'C&#x00F3;digo postal',
          cta: 'Buscar'
        },
      };
    }
    return copy;
  },

  getHeaderTextForResultsModal: function (keyMetrics) {
    var copy = {};
    if (keyMetrics && keyMetrics === 'live-chat-liveperson') {
      copy = {
        en: {
          title: 'Chat With A Local Dealer',
          subheading: 'Set your zip code and select a local dealer to start chatting.'
        },
        es: {
          title: 'Hablar con un dealer local',
          subheading: 'Pon tu código postal para hablar con un dealer local.'
        },
      };
    } else {
      copy = {
        en: { title: 'Select Your Dealer' },
        es: { title: 'Elegir concesionario' },
      };
    }
    return copy;
  }
};

export default dealerSearchModal;
